module.exports = __webpack_public_path__ + "static/media/kfc-24-9.849f7f41.jpg";